export default "__VITE_PUBLIC_ASSET__2e7d12f1__"